module.exports = __webpack_public_path__ + "static/cart-icon-d33a8e7ded00331852844087d9364d5b.png";